import React from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

const Card = (props) => {
  //console.log(props);
  const { tveeImgUrl } = props;
  const list = props.childProps.payload.list;
  const preText = props.childProps.state.prevMessage;

  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };

  const _goItem = (contentSerial) => {
    const { history } = props;
    history.push(`/items/${contentSerial}`);
  };
  return (
    <>
      <div className="scroll-container">
        {list.map((item) => (
          <div className="card">
            <img
              src={tveeImgUrl + '/images/tvee-admin/content/' + item.imageL}
              alt={item.title}
            />
            <div className="card-content">
              <h3>{item.title}</h3>
              <p>{item.contentSysnopsis}</p>
              <div className="btn" onClick={() => _goItem(item.contentSerial)}>
                바로가기
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText && (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};
export default shopContext(withRouter(Card));
